export const BACK4APP_URL = process.env.BACK4APP_URL;
export const BACK4APP_APPLICATIONID = process.env.BACK4APP_APPLICATIONID;
export const BACK4APP_JS_KEY = process.env.BACK4APP_JS_KEY;
export const BACK4APP_MASTER_KEY = process.env.BACK4APP_MASTER_KEY;

export const B4A_URL_IO = process.env.B4A_URL_IO;
export const B4A_APP_IO = process.env.B4A_APP_IO;
export const B4A_KEY_IO = process.env.B4A_KEY_IO;